module.exports = __webpack_public_path__ + "img/registration-bg.aedbd158.svg";